import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=23d45180&"
import script from "./DynamicForm.vue?vue&type=script&lang=js&"
export * from "./DynamicForm.vue?vue&type=script&lang=js&"
import style0 from "./DynamicForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports